import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjectSettingsService } from '@core/services/common/project-settings.service';
import { EndpointConstants } from '@core/services/endpoints-configurations/endpoint-constants';
import { IFeatureAvailability } from '@shared/interfaces/feature-availability.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FeatureAvailabilityApiService {
  private readonly options = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
  };

  constructor(
    private http: HttpClient,
    private settings: ProjectSettingsService,
  ) {}

  getAvailability(): Observable<IFeatureAvailability[]> {
    const url = this.settings.generateEndpoint(EndpointConstants.ApiFeatureAvailability);
    return this.http.get<IFeatureAvailability[]>(url, this.options).pipe(map((response) => response || []));
  }
}
